import { c as _c } from "react/compiler-runtime";
import RequiredIcon from '@/shared/assets/svg/required.svg';
import styles from './styles.module.scss';
interface TitleProps {
  label: string;
  size?: 13 | 14 | 16 | 18;
  icon?: React.ReactNode;
  className?: string;
  required?: boolean;
  id?: string;
  htmlFor?: string;
}
function Title(t0) {
  const $ = _c(18);
  const {
    label,
    size: t1,
    icon,
    className,
    required: t2,
    id,
    htmlFor
  } = t0;
  const size = t1 === undefined ? 14 : t1;
  const required = t2 === undefined ? false : t2;
  const sizeClass = styles[`size${size}` as keyof typeof styles] || styles.size14;
  let t3;
  if ($[0] !== required) {
    t3 = required && <RequiredIcon className={styles.required} />;
    $[0] = required;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== label || $[3] !== t3) {
    t4 = <>{label}{t3}</>;
    $[2] = label;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const labelContent = t4;
  let t5;
  if ($[5] !== className || $[6] !== sizeClass) {
    t5 = [styles.title, sizeClass, className].filter(Boolean);
    $[5] = className;
    $[6] = sizeClass;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = t5.join(" ");
  let t7;
  if ($[8] !== htmlFor || $[9] !== id || $[10] !== labelContent) {
    t7 = htmlFor ? <label htmlFor={htmlFor} id={id} className={styles.label}>{labelContent}</label> : <span id={id} className={styles.label}>{labelContent}</span>;
    $[8] = htmlFor;
    $[9] = id;
    $[10] = labelContent;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== icon) {
    t8 = icon ? <span className={styles.icon}>{icon}</span> : null;
    $[12] = icon;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t6 || $[15] !== t7 || $[16] !== t8) {
    t9 = <div className={t6}>{t7}{t8}</div>;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
}
Title.displayName = 'Title';
export default Title;